import { ReactNode } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { Box, Link, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { candidatesListPath } from '@utils';

const CONTENT_MAX_WIDTH = '48rem';

export const CandidateDetailsPageLayout: React.FC<{
  headerComponent: ReactNode;
  contentComponent: ReactNode;
  footerComponent: ReactNode;
  hideBreadcrumb?: boolean;
}> = ({
  headerComponent,
  contentComponent,
  footerComponent,
  hideBreadcrumb = false,
}) => {
  const { search } = useLocation();

  return (
    <Stack width="100%" pl={2} pr={{ xs: 2, tablet: 3 }} py={2}>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        maxWidth={CONTENT_MAX_WIDTH}
        width="100%"
        marginX="auto"
      >
        {!hideBreadcrumb && (
          <Link
            component={RouterLink}
            to={candidatesListPath(search)}
            underline="always"
            color="text.link"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              alignSelf: 'flex-start',
              gap: 0.75,
              fontSize: '0.875rem',
              textUnderlineOffset: '2px',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: 14 }} />
            Candidates
          </Link>
        )}

        {headerComponent}

        <Box width="100%">{contentComponent}</Box>

        {Boolean(footerComponent) && (
          <Box position="sticky" bottom={0} zIndex={9}>
            {footerComponent}
          </Box>
        )}
      </Box>
    </Stack>
  );
};
